import { type SireAncestry } from '../../models/SireAncestry';

export default function SireAncestryDisplay({
  sireAncestry,
}: {
  sireAncestry: SireAncestry;
}) {
  return (
    <div className='sire-ancestry'>
      {sireAncestry && (
        <div className='ancestry-display'>
          <p className='sire-dam sire-underline'>{sireAncestry.sire}</p>
          <p className='second-generation-sire sire-underline'>
            {sireAncestry.sireParent1}
          </p>
          <p className='second-generation-dam dam-underline'>
            {sireAncestry.damParent1}
          </p>
          <p className='third-generation-sire-sire sire-underline'>
            {sireAncestry.sireParent2}
          </p>
          <p className='third-generation-dam-sire dam-underline'>
            {sireAncestry.damParent2}
          </p>
          <p className='third-generation-sire-dam sire-underline'>
            {sireAncestry.sireParent3}
          </p>
          <p className='third-generation-dam-dam dam-underline'>
            {sireAncestry.damParent3}
          </p>
        </div>
      )}
    </div>
  );
}
